import { trigger, style, transition, animate, state, AnimationTriggerMetadata } from '@angular/animations';

const START_OPACITY = 0;
const FINAL_OPACITY = 1;
const DURATION_MS = 200;
const ANIMATION_TYPE = 'ease';

export const tooltipVisibilityAnimation: AnimationTriggerMetadata = trigger('visibility', [
  state(
    'initial, void, hidden',
    style({
      opacity: START_OPACITY,
      // sometimes tooltip freezes in 'initial' state and intercepts events from content underneath it.
      // prevent this behaviour by pointerEvents: 'none'
      pointerEvents: 'none',
    }),
  ),
  transition('* => visible', [
    style({ opacity: 0, transform: '{{ showTransform }}' }),
    animate(`${DURATION_MS}ms ${ANIMATION_TYPE}`, style({ opacity: FINAL_OPACITY, transform: 'translateY(0)' })),
  ]),
  transition('* => hidden', [
    animate(`${DURATION_MS}ms ${ANIMATION_TYPE}`, style({ opacity: START_OPACITY, transform: '{{ hideTransform }}' })),
  ]),
]);
